<template>
  <span>
    <slot :openModal="openModal">
      <button class="btn-reset p-0 font-weight-medium" @click.prevent.stop="showProfileEditModal = true">Add your name</button>
    </slot>
    <b-modal v-model="showProfileEditModal" title="Edit Profile Info" hide-footer size="lg">
      <onboarding-profile-edit :user-attributes="userAttributes" @cancel="showProfileEditModal = false"
                               @saved="handleProfileChanged"/>
    </b-modal>
  </span>
</template>
<script>
import OnboardingProfileEdit from "./OnboardingProfileEdit.vue";

export default {
  components: {OnboardingProfileEdit},
  mixins: [],
  props: {
    userAttributes: {
      type: Array,
      required: false,
      default: () => ['firstName', 'lastName']
    }
  },
  data() {
    return {
      showProfileEditModal: false
    }
  },
  mounted() {},
  methods: {
    openModal() {
      this.showProfileEditModal = true
    },
    handleProfileChanged() {
      this.showProfileEditModal = false
      window.location.reload()
    }
  },
  computed: {}
}
</script>